import React from 'react';
import { FaLinkedin, FaGithub } from 'react-icons/fa';
import { SiGmail } from 'react-icons/si';
import {
  FooterContainer,
  FooterWrap,
  SocialMedia,
  SocialMediaWrap,
  SocialLogo,
  WebsiteRights,
  SocialIcons,
  FooterInfo,
  StyledAnchor,
  SocialIconWrapper,
} from './FooterElements';
import { animateScroll as scroll } from 'react-scroll';

const Footer = () => {
  const toggleHome = () => {
    scroll.scrollToTop();
  };

  return (
    <FooterContainer>
      <FooterWrap>
        <SocialMedia>
          <SocialMediaWrap>
            <FooterInfo>
              <SocialLogo to="/" onClick={toggleHome}>
                Archit Jain
              </SocialLogo>
              <StyledAnchor
                href="mailto:arrchit.jain@gmail.com"
                target="_blank"
              >
                arrchit.jain@gmail.com
              </StyledAnchor>
              <WebsiteRights>
                © {new Date().getFullYear()} All rights reserved.
              </WebsiteRights>
            </FooterInfo>
            <SocialIcons>
              <SocialIconWrapper
                as="a"
                href="mailto:arrchit.jain@gmail.com"
                target="_blank"
              >
                <SiGmail />
              </SocialIconWrapper>
              <SocialIconWrapper
                as="a"
                href="https://linkedin.com/in/archit-jain19"
                target="_blank"
              >
                <FaLinkedin />
              </SocialIconWrapper>
              <SocialIconWrapper
                as="a"
                href="https://github.com/architjain19"
                target="_blank"
              >
                <FaGithub />
              </SocialIconWrapper>
            </SocialIcons>
          </SocialMediaWrap>
        </SocialMedia>
      </FooterWrap>
    </FooterContainer>
  );
};

export default Footer;
